import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";
import Spinner from "../../Components/Loading/Spinner";
import WorkflowButtons from "./Components/WorkflowButtons";
import InvoicesTable from "./Components/InvoicesTable";
// Libraries
import { SplitButton, Dropdown } from "react-bootstrap";
import moment from "moment/moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'




export default function ViewProduct() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [order, setOrder] = useState({

    });
    const [totals, setTotals] = useState({});

    


    

    useEffect(() => {
        

        // Load the order details
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Order:", res.data);
                setOrder(res.data);
                setLoading(false);


                var calcTotals = {
                    netContribution: 0
                };
                res.data.orderItems.map((item) => {
                   console.log("item:", item)
                    calcTotals.netContribution += item.netContribution;
                });

                console.log("totals:", calcTotals)

                setTotals(calcTotals);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });


    }, [])

    const generatePDF = (type) => {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/${params.id}/GeneratePDF?type=${type}`, {
                headers: { Authorization: `bearer ${user.token}` },
                responseType: 'blob', // had to add this one here
            })
            .then(response => {
                var url = window.URL.createObjectURL(response.data)
                var a = document.createElement('a')
                a.href = url
                a.download = `${order.id}.pdf`
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            })
            .catch(error => console.log(error));
    }

    const duplicateOrder = () => {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/${params.id}/Duplicate`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then(response => {
                console.log("response:", response); 
                window.open(`/Orders/Edit/${response.data.id}`);
            })
            .catch(error => console.log(error));
    }

   

    return (
        <div className="page" style={{paddingBottom: 100}}>

            {loading && (<Spinner />)}
            {!loading && (

                <>
                    <div className="row">
                        <div className="col-12">
                    <div className="row">
                        <div className="col-10">
                            <h1 style={{marginBottom: 0}}>
                                {order.id} 
                                {/* Edit Button */}
                                <Link to={`/Orders/Edit/${order.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>

                                {/* Duplicate Button */}
                                <button className="btn-sm btn-other" style={{ marginLeft: 10 }} onClick={duplicateOrder}>Duplicate</button>

                                {/* Generate PDF Button */}
                                <SplitButton
                                    key="other"
                                    id="dropdown-split-variants-other"
                                    variant="other"     
                                    size="sm"
                                    style={{ marginLeft: 10 }}
                                    title={
                                        <>
                                            <FontAwesomeIcon icon={faFilePdf} style={{ color: "#CC1311" }} className="me-1" />
                                            Generate PDF
                                        </>
                                    }
                                    onClick={() => { generatePDF('internal') }}
                                >
                                    <Dropdown.Item eventKey="1" onClick={() => { generatePDF('internal') }}>Internal PDF</Dropdown.Item>
                                    <Dropdown.Item eventKey="3" onClick={() => { generatePDF('supplier') }}>Supplier PDF</Dropdown.Item>
                                </SplitButton>
                                        



                            </h1>
                                    <p>Status: {order.status}</p>

                                    
                        </div>
                        <div className="col-2" style={{textAlign:"right"}}>

                            <WorkflowButtons order={order} setOrder={setOrder} />
                               
                        </div>
                            </div>
                        </div>
                    </div>

           

            
                    <div className="row" style={{marginTop:20}}>
                        <div className="col-md-6 p-0">

                
                            { /* Date Ordered */}
                            <div className="row">
                                <div className="col-4">
                                    Date Ordered
                                </div>
                                <div className="col-8">
                                    {order.dateOrdered && moment(order.dateOrdered).format('DD/MM/YYYY')}
                                </div>
                            </div>

                            { /* Date Required */}
                            <div className="row">
                                <div className="col-4">
                                    Date Required
                                </div>
                                <div className="col-8">
                                {order.dateRequired ? moment(order.dateRequired).format('DD/MM/YYYY') : "ASAP"}
                                </div>
                            </div>

                            { /* Date Required (Alternative) */}
                            {order.dateRequiredAlternate && (
                                <div className="row">
                                    <div className="col-4">
                                        Date Req. Alt.
                                    </div>
                                    <div className="col-8">
                                        {order.dateRequiredAlternate && moment(order.dateRequiredAlternate).format('DD/MM/YYYY')}
                                    </div>
                                </div>
                            )}
               
                        
                    

        

                            { /* Agent */}
                            <div className="row">
                                <div className="col-4">
                                    Agent
                                </div>
                                <div className="col-8">
                                    {order.agent && order.agent.name}
                                </div>
                            </div>

                            { /* Customer */}
                            <div className="row">
                                <div className="col-4">
                                    Customer
                                </div>
                                <div className="col-8">
                                    {order.customer && order.customer.name} 
                                </div>
                            </div>

                            { /* Farm */}
                            {order.farm && order.farm && (
                                <div className="row">
                                    <div className="col-4">
                                        Farm
                                    </div>
                                    <div className="col-8">
                                        {order.farm}
                                    </div>
                                </div>
                            )}

                            { /* Supplier */}
                            <div className="row">
                                <div className="col-4">
                                    Supplier
                                </div>
                                <div className="col-8">
                                    {order.supplier && order.supplier.name}
                                </div>
                            </div>

                            { /* Supplier Reference */}
                            <div className="row">
                                <div className="col-4">
                                    Supplier Reference
                                </div>
                                <div className="col-8">
                                    {order.supplier && order.supplierReference}
                                </div>
                            </div>

                            { /* Supplier Contact */}
                            {order.supplierContact && (
                                <div className="row">
                                    <div className="col-4">
                                        Supplier Contact
                                    </div>
                                    <div className="col-8">
                                        {order.supplierContact && order.supplierContact.name}<br />
                                        {order.supplierContact.phone && `Phone: ${order.supplierContact.phone}`}<br />
                                        {order.supplierContact.email && `Email: ${order.supplierContact.email}`}
                                    </div>
                                </div>
                            )}

                            { /* AFS or Supplier To Invoice */}
                            <div className="row">
                                <div className="col-4">
                                    Who Invoices?
                                </div>
                                <div className="col-8">
                                    {order && order.supplierToInvoice ? "Supplier" : "AFS"}
                                </div>
                            </div>

                            


                        
                        </div>
                        <div className="col-md-6">
                            { /* Invoice Account */}
                            <div className="row">
                                <div className="col-4">
                                    Invoice Account
                                </div>
                                <div className="col-8">
                                    {order.invoiceAccount}
                                </div>
                            </div>

                            { /* Delivery Account */}
                            <div className="row">
                                <div className="col-4">
                                    Delivery Account
                                </div>
                                <div className="col-8">
                                    {order.deliveryAccount}
                                </div>
                            </div>

                            { /* Agent Commission */}
                            <div className="row">
                                <div className="col-4">
                                    Agent Commission
                                </div>
                                <div className="col-8">
                                    &pound;{order.agentCommission && order.agentCommission.toFixed(2)}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row" style={{ marginTop: 20 }}>
                        <div className="col-3">
                            <strong>Billing Address</strong>

                            {/* Billing Address */}
                            <div className="col-8 p-0" style={{ whiteSpace: "pre-line" }}>
                                {order.billingAddress}
                            </div>

                            {/* Billing Postcode */}
                            <div className="col-8 p-0">
                                {order.billingPostcode}
                            </div>
                        </div>

                        <div className="col-3">
                            <strong>Delivery Address</strong>

                            {order.deliveryAddress ? (
                                <>
                                    {/* Delivery Address */}
                                    <div className="col-8" style={{ whiteSpace: "pre-line" }}>
                                        {order.deliveryAddress}
                                    </div>

                                    {/* Delivery Postcode */}
                                    <div className="col-8">
                                        {order.deliveryPostcode}
                                    </div>
                                </>
                            ) : (<div className="col-12" style={{ whiteSpace: "pre-line" }}>
                                    <em>Same as billing address</em>
                                 </div>)}
                        </div>
                    </div>


                <div className="row">
                    <div className="col-12">
                        <div style={{ marginBottom: 40, marginTop: 40 }}>
                            <table style={{ width: "100%", marginBottom: 10 }}>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right",  width: 80 }}>Qty<br />Ordered</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right",  width: 80 }}>Qty<br />Del.</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right", width: 120 }}>Haulage<br />Rate</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right", width: 120 }}>AFS<br />Cost Price</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right", width: 120 }}>Agent<br />Cost Price</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right", width: 120 }}>Sale<br />Price</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right", width: 120 }}>Net<br/> Contrib.</th>
                                        <th style={{ width: 50 }}>&nbsp;</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {order.orderItems && order.orderItems.map((item) => (

                                        <tr key={item.id}>
                                            <td>{item.productCode && (item.productCode + " - ")}{item.productName}</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>{item.quantityOrdered}</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>{item.quantityDelivered}</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{item.haulageRate.toFixed(2)}</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{item.costPrice.toFixed(2)}</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{item.agentCostPrice.toFixed(2)}</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{item.salePrice.toFixed(2)}</td>
                                            <td className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{item.netContribution.toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>

                                        {totals && (
                                <tfoot>
                                    <tr>
                                        <th></th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right" }}></th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right" }}></th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right" }}></th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right" }}></th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right" }}></th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>Total</th>
                                        <th className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>&pound;{totals && totals.netContribution.toFixed(2)}</th>
                                    </tr>
                                </tfoot>
                            )}
                            </table>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        { /* Comments */ }
                        <div className="row">
                            <div className="col-4">
                                Comments
                            </div>
                            <div className="col-8">
                                {order.comments}
                            </div>
                        </div>

                        { /* Haulier */}
                        <div className="row">
                            <div className="col-4">
                                Haulier
                            </div>
                            <div className="col-8">
                                {order.haulier}
                            </div>
                        </div>

                        { /* Invoice Number */}
                        <div className="row">
                            <div className="col-4">
                                AFS Invoice No.
                            </div>
                            <div className="col-8">
                                {order.invoiceNumber}
                            </div>
                        </div>

                        { /* Bill Number */}
                        <div className="row">
                            <div className="col-4">
                                AFS Bill No.
                            </div>
                            <div className="col-8">
                                {order.billNumber}
                            </div>
                        </div>

                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-4">
                                <h3>Audit Trail</h3>
                            </div>
                        </div>


                        {order.auditTrail && order.auditTrail.map((entry) => (
                            <div className="row">
                                <div className="col-4">
                                    {entry.action}
                                </div>
                                <div className="col-8">
                                    {entry.date && moment(entry.date).format('DD/MM/YYYY HH:mm')} ({entry.user})
                                </div>
                            </div>

                        ))}
                    </div>
                </div>

                {/*{*/}
                {/* Removed for now... reactivate when linked to Xero */}
                {/*    (order.status == "Paid" || order.status == "Approved") && <InvoicesTable order={order} />*/}
                {/*}      */}

        </>
    )}


            
            

        </div>
  )
}
